import '../shared/pwa.css';
import { createApp } from 'vue';
import { createPinia } from 'pinia';
import App from './App.vue';
import router from './router';
import { useAppMetaStore } from './stores/appMeta';

// Registro manual com scope '/' porque as páginas são servidas no root do subdomínio
// (ex: armazem-10.borabeber.local/), não sob /pwa/client/. O nginx precisa responder
// com Service-Worker-Allowed: / para permitir o scope mais amplo.
if ('serviceWorker' in navigator) {
    const swPath = import.meta.env.DEV ? '/sw.js' : '/pwa/client/sw.js';
    navigator.serviceWorker.register(swPath, { scope: '/' }).catch(console.error);
}

const app = createApp(App);
const pinia = createPinia();

app.use(pinia);
app.use(router);

// Resolve tenant meta as early as possible so tenantId is ready
// before the user interacts with any auth action
useAppMetaStore().fetchMeta();

app.mount('#app');
